<template>
  <div class="errorMessagesBox" v-if="errorMessages">
    <p v-for="errorMessage in errorMessages">{{errorMessage}}</p>
  </div>
</template>
<script>export default {
    name: 'ErrorMessageBox',
    props: ['errorMessages'],
    data() {
      return {}
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Utility/ErrorMessageBox.vue